import { ColumnDef } from "@tanstack/react-table";
import { IndeterminateCheckbox } from "./IndeterminateCheckbox";

export function TanstackCheckboxes<T>(
  getIsRowDisabled?: (row: T) => boolean,
): ColumnDef<T> {
  return {
    id: "select",
    size: 0,
    header: ({ table }) => (
      <span className="px-1">
        <IndeterminateCheckbox
          checked={table.getIsAllRowsSelected()}
          indeterminate={table.getIsSomeRowsSelected()}
          onChange={() => {
            if (getIsRowDisabled) {
              const newValue = !table.getIsAllRowsSelected();
              table.toggleAllPageRowsSelected(false);
              if (newValue) {
                table.getRowModel().rows.forEach((row) => {
                  if (!getIsRowDisabled(row.original)) {
                    row.toggleSelected(true);
                  }
                });
              }
            } else {
              table.toggleAllRowsSelected();
            }
          }}
        />
      </span>
    ),
    cell: ({ row }) => (
      <span className="px-1">
        <IndeterminateCheckbox
          checked={row.getIsSelected()}
          disabled={
            !row.getCanSelect() ||
            (getIsRowDisabled && getIsRowDisabled(row.original))
          }
          indeterminate={row.getIsSomeSelected()}
          onChange={row.getToggleSelectedHandler()}
        />
      </span>
    ),
  };
}
